import * as Request from '../Request';
const CheckTable = {
  // 从检查标准库导入
  importByCheckStandard: (data) => {
    return Request.post('/checklist/importByCheckStandard', data)
  },
  // 检查表类型列表
  typeList: (data) => {
    return Request.get('/checklist/type/list', data)
  },
  // 列表
  getList: (data) => {
    return Request.post('/checklist/list', data)
  },
  // 新增列表
  saveList: (data) => {
    return Request.post('/checklist/save', data)
  },
  // 更新列表
  updateList: (data) => {
    return Request.put('/checklist/update', data)
  },
  // 删除
  delList: (data) => {
    return Request.delBody('/checklist/delete', data)
  },
  // 详情
  listInfo: (data) => {
    return Request.get('/checklist/info', data)
  },
  // 检查标准列表
  getItemList: (data) => {
    return Request.post('/checklist/item/list', data)
  },
  // 检查标准新增
  saveItemList: (data) => {
    return Request.post('/checklist/item/save', data)
  },
  // 检查标准修改
  updateItemList: (data) => {
    return Request.put('/checklist/item/update', data)
  },
  // 检查标准删除
  delItemList: (data) => {
    return Request.delBody('/checklist/item/delete', data)
  },
  // 检查标准详情
  itemListInfo: (data) => {
    return Request.get('/checklist/item/info', data)
  },
  // 检查项目列表
  getDirList: (data) => {
    return Request.post('/checklist/directory/list', data)
  },
  // 检查项目新增
  saveDirList: (data) => {
    return Request.post('/checklist/directory/save', data)
  },
  // 检查项目修改
  updateDirList: (data) => {
    return Request.put('/checklist/directory/update', data)
  },
  // 检查项目删除
  delDirList: (data) => {
    return Request.delBody('/checklist/directory/delete', data)
  }
}
export default CheckTable
